import React from "react"
import { useSelector } from "react-redux"
import { MarkingWordsCrud } from "."
import { statuses, queryClient as qc, alerts as alertsKeys, prosodies } from "keys"
import { useCallback, useContext } from "react"
import { useAlert } from "components/Alerts/hooks"
import { surferHooks } from "components/Record"
import { MarkingWordsContext } from "../MarkingWordsContext"
import { updateBrokenFileStatusFetch } from "store/middlewares/markingWords.crud"
import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { app } from "router/routes"
import { actions } from "store"
import { useDispatch } from "react-redux"

const useHeaderActions = () => {
    const { setAlerts } = useAlert()
    const dispatch = useDispatch()

    const { isCloseSttoper } = useSelector(state => state.markingWords)
    const { isPlaying } = useSelector(state => state.wavesurfer)
    const onPause = surferHooks.useOnPause()
    const navigate = useNavigate()

    const { assessment } = useSelector(state => state.assessment)
    const { mutateAsync: updateBrokenFileStatusRQ, isPending: updateBrokenFileStatusLoading } = useMutation({ mutationFn: updateBrokenFileStatusFetch })

    const updateBrokenFileStatus = async () => {
        await updateBrokenFileStatusRQ(assessment)
        navigate(app.markingWordsAssessments)
    }

    const openInitializeConfirmation = useCallback(() => {
        onPause()
        setAlerts(alertsKeys.initializeAssessment, true)
    }, [isPlaying])

    const updateProsody = useCallback((val) => {
        dispatch(actions.setAssessment({ ...assessment, prosody: val }))
    }, [assessment])

    const brokenFile = {
        [statuses.inProgress]: {
            [statuses.wordsInProgress]: {

            },
            [statuses.wordsComplete]: {
            }
        },
        [statuses.uploaded]: {
            "default": {
            }
        },
        [statuses.backToMarking]: {
            "default": {
            }
        },
        [statuses.brokenFile]: {
            "default": {
            }
        }
    }

    const brokenFileProps = brokenFile[assessment.status]?.[assessment.sub_status || "default"]

    const headerActions = React.useMemo(
        () =>
            [
                {
                    id: 1,
                    name: "prosody",
                    placeholder: "פרוזודיה",
                    width: 80,
                    options: prosodies,
                    component: 'autoComplete',
                    input: {
                        value: assessment.prosody,
                        onChange: updateProsody
                    },
                    disabled: isCloseSttoper
                },
                {
                    id: 1,
                    label: "איפוס",
                    color: "rating3",
                    action: openInitializeConfirmation,
                    width: 80,
                    component: 'button',
                },
                {
                    label: "אודיו לא תקין",
                    color: "dark",
                    action: updateBrokenFileStatus,
                    loading: updateBrokenFileStatusLoading,
                    width: 110,
                    component: 'button',
                    disabled: assessment?.sub_status != statuses.wordsInProgress,
                    hide: brokenFileProps?.hide,
                    disabledColor: "gray2"
                }
            ],
        [assessment, isCloseSttoper]
    );

    return headerActions
}

export default useHeaderActions